var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-container",style:({
    gap: _vm.pageGap ? '20px' : '0px',
    '--header-color': _vm.questions.style.colorScheme.header,
    '--body-color': _vm.questions.style.colorScheme.body,
    '--footer-color': _vm.questions.style.colorScheme.footer,
    '--heading-color': _vm.questions.style.heading.color,
    '--heading-size': _vm.questions.style.heading.size + 'px',
    '--heading-weight': _vm.questions.style.heading.bold ? 'bold' : 'normal',
    '--heading-style': _vm.questions.style.heading.italic ? 'italic' : 'normal',
    '--heading-decoration': _vm.questions.style.heading.underline
      ? 'underline'
      : 'none',
    '--heading-font': _vm.questions.style.heading.font,
    '--label-color': _vm.questions.style.label.color,
    '--label-size': _vm.questions.style.label.size + 'px',
    '--label-weight': _vm.questions.style.label.bold ? 'bold' : 'normal',
    '--label-style': _vm.questions.style.label.italic ? 'italic' : 'normal',
    '--label-decoration': _vm.questions.style.label.underline
      ? 'underline'
      : 'none',
    '--label-font': _vm.questions.style.label.font,
    '--text-color': _vm.questions.style.text.color,
    '--text-size': _vm.questions.style.text.size + 'px',
    '--text-weight': _vm.questions.style.text.bold ? 'bold' : 'normal',
    '--text-style': _vm.questions.style.text.italic ? 'italic' : 'normal',
    '--text-decoration': _vm.questions.style.text.underline
      ? 'underline'
      : 'none',
    '--text-font': _vm.questions.style.text.font,
  })},_vm._l((_vm.pages),function(page,pageIndex){return _c('div',{key:pageIndex,staticClass:"sub-container page-unit"},[_c('div',{staticClass:"banner header-banner"},[_c('h2',[_vm._v(_vm._s(_vm.questions.title))])]),_c('div',{staticClass:"page-container"},[_c('div',{staticClass:"project-info "},_vm._l((page),function(item,index){return _c('div',{key:index,staticClass:"section"},[(item.heading)?_c('h2',{staticClass:"heading"},[_c('SpellCheckedText',{attrs:{"value":item.heading},on:{"input":function($event){item.heading = $event}}})],1):_vm._e(),_c('div',{staticClass:"desc"},[_c('SpellCheckedText',{attrs:{"value":item.response},on:{"input":function($event){item.response = $event}}})],1)])}),0)]),_c('div',{staticClass:"banner footer-banner"},[_c('span',{staticClass:"page-number"},[_vm._v(_vm._s(String(_vm.startPage + pageIndex).padStart(2, '0')))])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }